import React, { useEffect, useRef } from 'react';
import InnerBanner from '../component/InnerBanner';
import axios from 'axios';
import Loader from '../component/Loader';
import { Row, Col } from 'antd';
import { IoIosArrowRoundForward } from "react-icons/io";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { gsap } from 'gsap';
import { Link, useParams } from 'react-router-dom';
import Card from '../component/card';
import { useContext, useState } from 'react';
import { ProductContext } from '../context/productContext';
import secureLocalStorage from 'react-secure-storage';
import { useSettings } from '../context/settingContext';

function Categrios() {
    const slidesRef = useRef([]);
    const { id } = useParams();
    const { products, loading } = useContext(ProductContext);

    const [banner, setBanner] = useState(null);
    // const [pageContent, setPageContent] = useState(null);

    useEffect(() => {
        slidesRef.current.forEach((slide, i) => {
            if (slide) {
                gsap.fromTo(
                    slide,
                    { opacity: 0, y: 50 },
                    {
                        opacity: 1,
                        y: 0,
                        duration: 1,
                        delay: i * 0.2,
                        scrollTrigger: {
                            trigger: slide,
                            start: 'top 85%',
                            toggleActions: 'play none none none',
                        },
                    }
                );
            }
        });
    }, [products, id]);

    const getBanner = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}api/get-content/CategoryPage`);
            setBanner(res.data.data[0]);
        } catch (err) {
            console.log('Fetching Banner Content', err);
        }
    };

    // const getPageContent = async () => {
    //     try {
    //         const res = await axios.get(`${process.env.REACT_APP_API_URL}api/get-content/CategoryPageContent`);
    //         setPageContent(res.data.data);
    //     } catch (err) {
    //         console.log('Fetching Page Content', err);
    //     }
    // };

    useEffect(() => {
        getBanner();
        // getPageContent();
    }, []);

    const [wishlist, setWishlist] = useState([]);
    const { user } = useSettings();
    const userId = user?.id;

    useEffect(() => {
        const fetchWishlist = async () => {
            if (!userId) return;
            try {
                const res = await axios.get(`${process.env.REACT_APP_API_URL}api/listing-wishlist?user_id=${userId}`);
                setWishlist(res.data.data || []);
            } catch (err) {
                console.log("Error fetching wishlist:", err);
            }
        };
        fetchWishlist();
    }, [userId]);

    if (loading || banner === null) {
        return <Loader />;
    }

    const categoryProducts = products.filter(
        (item) => Number(item.category_id) === Number(id)
    );

    return (
        <div>
            <section className="main-categrios">
                <InnerBanner secttile={banner.sub_title} title={banner.title} />

                <div className="main-droper bg-black pt-20 pb-20">
                    <div className="container mx-auto px-4">
                        <Row gutter={20} className="crafted-row motion-flex align-items-center">
                            {/* <Col span={8}>
                                <div className="text-1">
                                    <h1 className='font-syne text-4xl font-bold bg-[linear-gradient(90deg,_rgba(67,170,214,1)_60%,_rgba(0,0,0,1)_100%)] bg-clip-text text-transparent'>
                                        {pageContent[0].title}
                                    </h1>
                                    <p className='text-[15px] font-outfit text-white pt-[25px] pb-5 w-[480px]'>
                                        {pageContent[0].details}
                                    </p>
                                    <Link to="/shop"
                                        className="bg-white font-syne w-fit p-3 font-thin rounded-full outline-none flex items-center justify-between gap-2 hover:bg-[linear-gradient(90deg,_rgba(67,170,214,1)_0%,_rgba(0,0,0,1)_100%)] hover:text-white transition-all duration-300">
                                        <span className="font-medium hover:text-white">Shop the Collection</span>
                                        <IoIosArrowRoundForward className="text-xl" />
                                    </Link>
                                </div>
                            </Col> */}
                            <Col span={24}>
                                {categoryProducts.length === 0 ? (
                                    <div className="not_found_wrp">No products found in this category.</div>
                                ) : (
                                    <Swiper
                                        modules={[Navigation]}
                                        navigation
                                        spaceBetween={20}
                                        slidesPerView={4}
                                        className="crafted-swiper"
                                    >
                                        {categoryProducts.map((product, index) => (
                                            <SwiperSlide key={product.id}>
                                                <div ref={(el) => (slidesRef.current[index] = el)}>
                                                    <Card
                                                        key={product.id}
                                                        {...product}
                                                        isWishlisted={
                                                            wishlist.some((item) => item.item_id === product.id)
                                                        }
                                                    />
                                                </div>
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                )}
                            </Col>
                        </Row>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Categrios;
